/* Countdown timer functions
 */

function parseDiff(diff) {
    days = Math.floor(diff / (24 * 60 * 60));
    totalsecs = diff - (days * 24 * 60 * 60);
    hours = Math.floor(totalsecs / (60 * 60));
    mins = Math.floor((totalsecs - hours * 60 * 60) / 60);
    secs = totalsecs - hours * 60 * 60 - mins * 60;
    return [days, hours, mins, secs];
}

function fillCounter(counter) {
    jQuery(".counter-date #day").html(counter[0]);
    jQuery(".counter-date #hour").html(counter[1]);
    jQuery(".counter-date #min").html(counter[2]);
    jQuery(".counter-date #sec").html(counter[3]);
}

function counterMain(counterDownEndDate)
{
    var ma = new Date();
    var timeZone = ma.getTimezoneOffset();
    most = Math.floor((Date.now() - timeZone * 60 * 1000) / 1000);
    var diff = counterDownEndDate - most;

    if (diff < 0) {
        jQuery("#counter").html("");
        return "END";
    } else {
        fillCounter(parseDiff(diff));
    }
    return "";
}

jQuery(function () {
    if (typeof(counterDownEndDate) === "undefined") {
        return ;
    }
    var x = setInterval(function () {
        if (counterMain(counterDownEndDate) === "END") {
            clearInterval(x);
        }
    }, 1000);
});
